{
  "pull": "Pull down to reload...",
  "release": "Release to reload...",
  "labelRows": "rows",
  "tableRowsDisplayed": "{from}-{to} of {count}",
  "tableFirstPage": "First Page",
  "tableLastPage": "Last Page",
  "tableNextPage": "Next Page",
  "tablePreviousPage": "Previous Page",
  "tableSearchTooltip": "Search",
  "tableSearchPlaceholder": "Search",
  "tableSearchAriaLabel": "Search",
  "tableSearch": "Search...",
  "tableClearSearchAriaLabel": "Clear Search",
  "tableRowsPerPage": "Rows per page:",
  "sortBy": "SORT BY",
  "showFiltersAndSorting": "Show Filters & Sorting",
  "hideFiltersAndSorting": "Hide Filters & Sorting",
  "searchPlaceholder": "Search By {{searchKeys}}",
  "all": "All",
  "noRecords": "No records to display",
  "listTable": {
    "filters": "Filters",
    "columns": "Columns",
    "drawers": {
      "columns": {
        "title": "Columns",
        "columns": {
          "show": "Show",
          "columnName": "Column Name"
        }
      },
      "filters": {
        "title": "Filters"
      },
      "buttons": {
        "cancel": "Close",
        "restoreDefaults": "Restore Defaults",
        "apply": "Apply"
      }
    }
  }
}
